/**
 * @flow
 * @relayHash d01306c6e35182186053fede2df826a9
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SelectProductionTypeFieldQueryVariables = {||};
export type SelectProductionTypeFieldQueryResponse = {|
  +productionTypes: $ReadOnlyArray<{|
    +id: string,
    +name: string,
  |}>
|};
export type SelectProductionTypeFieldQuery = {|
  variables: SelectProductionTypeFieldQueryVariables,
  response: SelectProductionTypeFieldQueryResponse,
|};
*/


/*
query SelectProductionTypeFieldQuery {
  productionTypes {
    id
    name
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "productionTypes",
    "storageKey": null,
    "args": null,
    "concreteType": "ProductionType",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SelectProductionTypeFieldQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "SelectProductionTypeFieldQuery",
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "SelectProductionTypeFieldQuery",
    "id": null,
    "text": "query SelectProductionTypeFieldQuery {\n  productionTypes {\n    id\n    name\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '69d3034a19048a8dbc36241d5e7323ff';
module.exports = node;
